/* @flow */
import React from 'react';
import Hit from '../Hit/Hit';
import type {ListingShape} from '../Hit/Hit';
import type {SearchParamsType} from '../../reducers/searchParams';

type Props = {
    listingData: ListingShape,
    isDatelessSearch?: boolean,
    index: number,
    inputParams: SearchParamsType
};

export default function ExpandedGroupHitPlaceholder({
    listingData,
    index,
    inputParams
}: Props) {
    return (
        <div className={'ExpandedGroupHitPlaceholder'}>
            <div className={'ExpandedGroupPlaceholder__hit'}>
                <Hit
                    listing={listingData}
                    index={index}
                    hitIndex={index}
                    inputParams={inputParams}
                />
            </div>
            <div className={'ExpandedGroupHitPlaceholder__overlay'} />
        </div>
    );
}
